import { render } from "./RankingListCard.vue?vue&type=template&id=b4c98f2a"
import script from "./RankingListCard.vue?vue&type=script&lang=js"
export * from "./RankingListCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__